import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";

import { Router } from "@angular/router";
import { AppConfig } from "./../config";

import { DataService } from "./../data.service";
import { SharedDataService } from "../shared-data.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  form: FormGroup;

  isError = false;
  isLoading = false;
  errorMessage = "";
  organizations = [];
  products = [];

  constructor(
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private router: Router,
    private dataService: DataService,
    private toastrService: ToastService,
    private SharedDataService: SharedDataService
  ) {
    // private store: Store
  }

  ngOnInit() {
    this.form = this.fb.group({
      username: ["admin@ibrookinfotech.com", Validators.required],
      password: ["12345", Validators.required],
      organization: "",
      organizationname: "",
      organizationid: "",
      product: "",
      productname: "",
      productid: ""
    });

    this.dataService.getAllOrganizations().subscribe(
      (res) => {
        // this.organizations = res
        console.log(res);
        if (res !== null) {
          var organizationsAll = res;
          var orgArr = [];
          //just add an empty entry sice this field is optional
          orgArr.push({ value: "", label: "--None--" });
          for (let i = 0; i < organizationsAll.length; i++) {
            orgArr.push({
              value: organizationsAll[i].id,
              // label: organizationsAll[i].name,
              label: `${organizationsAll[i].name} || ${organizationsAll[i].environmenttype}`
            });
          }
          this.organizations = orgArr;
          this.isLoading = false;
        } else {
          console.log("No organization data!");
          this.errorMessage =
            res != null ? res.message : "No organization data!";
          this.isError = true;
          this.isLoading = false;
        }
      },
      (error) => {
        console.error("error: ", error);
      }
    );

    this.dataService.getAllProducts().subscribe(
      (res) => {
        // this.organizations = res
        console.log(res);
        if (res !== null) {
          var productsAll = res;
          var prodArr = [];
          //just add an empty entry sice this field is optional
          prodArr.push({ value: "", label: "--None--" });
          for (let i = 0; i < productsAll.length; i++) {
            prodArr.push({
              value: productsAll[i].id,
              label: productsAll[i].name
            });
          }
          this.products = prodArr;
          this.isLoading = false;
        } else {
          console.log("No Product data!");
          this.errorMessage = res != null ? res.message : "No Product data!";
          this.isError = true;
          this.isLoading = false;
        }
      },
      (error) => {
        console.error("error: ", error);
      }
    );
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Login Error!", options);
  }

  organizationChange(event: { value: string; label: any }) {
    console.log("OrganizationChange", event);
    if (event.value.trim() != "") {
      this.form.controls["organizationname"].setValue(event.label);
      this.form.controls["organizationid"].setValue(event.value);
    } else {
      this.form.controls["organizationname"].setValue("");
      this.form.controls["organizationid"].setValue("");
    }
  }

  productChange(event: { value: string; label: any }) {
    console.log("Product Change", event);
    if (event.value.trim() != "") {
      this.form.controls["productname"].setValue(event.label);
      this.form.controls["productid"].setValue(event.value);
    } else {
      this.form.controls["productname"].setValue("");
      this.form.controls["productid"].setValue("");
    }
  }

  onSubmit() {
    console.log(this.form.valid);
    if (this.form.controls["username"].value == "") {
      this.showError("Please enter your User Name");
    }

    if (this.form.controls["password"].value == "") {
      this.showError("Please enter your Password");
    }

    if (this.form.valid) {
      //prepare data for saving: application
      let postOption = {
        data: {
          username: this.form.controls["username"].value,
          password: this.form.controls["password"].value,
          productid: this.form.controls["productid"].value,
          organizationid: this.form.controls["organizationid"].value
        }
      };

      console.log(postOption);

      this.isLoading = true;
      this.dataService.login(postOption).subscribe(
        (res) => {
          //alert('****res****' + JSON.stringify(res));
          console.log("res", res);
          if (res.success == 1) {
            console.log("success");

            this.showSuccess(res.message);

            var userDetails = res.userdetails;

            console.log("userDetails", userDetails);

            //store it in local storage for later access
            localStorage.setItem("crm_orgid", userDetails.organizationid);
            localStorage.setItem("crm_userid", userDetails.userid);
            localStorage.setItem("crm_loginid", userDetails.username);
            localStorage.setItem("crm_username", userDetails.name);
            localStorage.setItem("crm_useralias", userDetails.alias);
            localStorage.setItem("crm_profilename", userDetails.profilename);
            localStorage.setItem("crm_profileid", userDetails.profileid);
            localStorage.setItem(
              "crm_metaapplicationid",
              userDetails.metaapplicationid
            );
            localStorage.setItem(
              `${userDetails.organizationid}.domain`,
              userDetails.domain
            );
            localStorage.setItem(
              `${userDetails.organizationid}.subdomain`,
              userDetails.subdomain
            );

            localStorage.setItem(
              "crm_userlicense",
              userDetails.userlicensename
            );

            localStorage.setItem(
              "crm_metaobjects",
              JSON.stringify(res.metaobjects)
            );
            localStorage.setItem(
              "crm_userdetails",
              JSON.stringify(userDetails)
            );
            localStorage.setItem("isLoggedIn", "true");
            // this.store.dispatch(login());

            console.log("localstorage", localStorage);

            this.SharedDataService.setUserDetails(userDetails);

            this.router.navigateByUrl("/home");

            this.isLoading = false;
          } else {
            console.log("error while login");
            this.showError(res.message);
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.showError(err.message);
          this.isError = true;
          this.isLoading = false;
        }
      );
    }
  }
}
